import { useEffect } from "react";
import { useRootStore } from "../stores/RootStoreContext";

export const useBlocker = (pred: boolean, msg: string) => {
  const history = useRootStore().history;

  return useEffect(() => {
    if (pred) {
      const cleanup = history.block(msg);
      return () => {
        cleanup();
      };
    }
  }, [history, msg, pred]);
};
